import { routeName } from 'app/routes/route-constants';
import { CaseConnectionParam } from 'app/infrastructure/ui/form/types';
import * as History from 'history';
import { LocationDescriptorObject } from 'history';

/**
 * Serialize router query parameters to a object array, in reverse/chronological order
 *
 * @param query 
 */
// eslint:disable-next-line:one-variable-per-declaration
export const deserializeConnectionState =  (query: History.Query) : CaseConnectionParam[] => (
  
  Array.isArray(query.draftId)  ?

    query.draftId.map( (val,i) => ({ 
      draftId: Number(val),
      connectionTypeId: Number(query.connectionTypeId[i]),
      sequence: Number(query.sequence[i])
    }))
    :  
    query.draftId ? 

      [{
        draftId: Number(query.draftId),
        connectionTypeId: Number(query.connectionTypeId),
        sequence: Number(query.sequence)
      }]
      :
      undefined 
);

/**
 * Serialize as query string
 * 
 * @param queue 
 */
export const serializeConnectionState = (queue: CaseConnectionParam[]) => {
  if(!queue || !queue.length){
    return '';
  }
  // TODO: It seems like there always has to be connectionTypeId and sequence for each draft in the stack for deserialize to work
  const qs = queue.reverse().map( 
    item => `draftId=${item.draftId}&connectionTypeId=${item.connectionTypeId || 0}&sequence=${item.sequence || 0}`
  ).join('&');

  return qs ? `?${qs}` : '';
};

/**
 * Create a routable link to the previous item in the case connection chain, preserving it's queue state
 * 
 * @param queue 
 */
export const getLocationOfInitiator = (queue: CaseConnectionParam[]): LocationDescriptorObject => {
  if(!queue || !queue.length){
    return undefined;
  }
  const { [queue.length -1] : lastItem } = queue;
  if(!lastItem || !lastItem.draftId){
    throw new Error('Invalid id for draft location');
  }
  return ({ 
    pathname: `/${routeName.Draft}/${lastItem.draftId}`,
    state: {internal: false} ,
    search: serializeConnectionState(queue.slice(0, -1))
  });
};
